/**
 * Statistics Win Rate Chart Wrapper
 * Used on the Statistics page - uses global date selector (no individual timeframe selector)
 */

import React from "react";
import WinRateChart from "../../Dashboard/components/WinRateChart";
import ChartCard from "../../Dashboard/components/ChartCard";

interface StatisticsWinRateChartProps {
  brokerAccountCode: string;
  timeframe: "today" | "7-days" | "14-days" | "30-days" | "all-time";
  startDate?: Date;
  endDate?: Date;
  localStartDate?: string;
  localEndDate?: string;
  reportingTimezone?: string | null;
  percentage: number;
  value: number;
  valueFormatter: (val: number) => string;
  onLatestCumulativeWinRateChange: (value: number) => void;
  useHourly?: boolean;
}

const StatisticsWinRateChart: React.FC<StatisticsWinRateChartProps> = ({
  brokerAccountCode,
  timeframe,
  startDate,
  endDate,
  localStartDate,
  localEndDate,
  reportingTimezone,
  percentage,
  value,
  valueFormatter,
  onLatestCumulativeWinRateChange,
  useHourly,
}) => {
  const [showAverageWinRate, setShowAverageWinRate] = React.useState<boolean>(true);

  return (
    <ChartCard
      title="Win Rate Trend"
      percentage={percentage}
      chart={
        <WinRateChart
          brokerAccountCode={brokerAccountCode}
          period={useHourly ? "hourly" : "daily"}
          timeframe={timeframe}
          startDate={startDate}
          endDate={endDate}
          localStartDate={localStartDate}
          localEndDate={localEndDate}
          reportingTimezone={reportingTimezone}
          fullChart={true}
          viewOptions={{ averageWinRate: showAverageWinRate }}
          onLatestCumulativeWinRateChange={onLatestCumulativeWinRateChange}
        />
      }
      value={value}
      valueFormatter={valueFormatter}
      // No timeframe selector - controlled from main selector only
      showViewSelector={true}
      viewOptions={{
        portfolioValue: true,
        tradingPnlOnly: false,
        transfers: false,
        averageWinRate: showAverageWinRate,
      }}
      onViewOptionsChange={(opts) => {
        setShowAverageWinRate(opts.averageWinRate ?? true);
      }}
    />
  );
};

export default StatisticsWinRateChart;
